import React from "react";
import Logo from "../../resources/RezolveAI_Logo.svg";
import * as styled from "./styled";
import DropdownMenu from "../DropdownMenu";
import { useStore } from "../../hooks/useSharedContext";
import useIsMobile from "../../hooks/useIsMobile";

const AppHeader = ({ ariaHidden }: { ariaHidden?: boolean }) => {
  const store = useStore();
  const isMobile = useIsMobile();
  return (
    <styled.HeaderWrapper aria-hidden={ariaHidden} role="banner">
      <styled.LogoImage
        src={Logo}
        title="Rezolve AI Logo"
        alt="Rezolve AI Logo"
        isMobile={isMobile}
      />
      <styled.HeaderText>{store?.storeName}</styled.HeaderText>
      <styled.MenuButtonWrapper>
        <DropdownMenu store={store} />
      </styled.MenuButtonWrapper>
    </styled.HeaderWrapper>
  );
};

export default AppHeader;
